import { Component, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-variables-dashboard',
  templateUrl: './select-variables-dashboard.component.html',
  styleUrls: ['./select-variables-dashboard.component.scss']
})
export class SelectVariablesDashboardComponent implements  OnDestroy {

  public items: any[] = [
    { value: 'volume', variable: 'volume', name: 'Volumen de Venta' },
    { value: 'selling_price', variable: 'sellingPrice', name: 'Precio de Venta' },
    { value: 'purchase_price', variable: 'purchasePrice', name: 'Precio de Compra' },
    { value: 'purchase_margin', variable: 'purchaseMargin', name: 'Margen $' },
    { value: 'price_tar', variable: 'priceTar', name: 'Precio TAR' },
    { value: 'ppc', variable: 'ppc', name: 'Precio de Comp' },
    { value: 'quotient', variable: 'quotient', name: 'Indice de Precios' },
    { value: 'diff_selling_price', variable: 'diffSellingPrice', name: 'Dif Precio Vs Comp' },
  ];

  public variableSelected: any = [];
  public ngxDisabled = true;
  variableSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.variableSelected$ = sharedService.sharedVariableDashboard.subscribe((variableSelected: string) => {
      if (this.variableSelected !== variableSelected) {
        this.variableSelected = variableSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnDestroy() {
    this.variableSelected$.unsubscribe();
  }

  changeVariable(event: any) {
    this.variableSelected = event;
    this.sharedService.nextVariableDashboard = this.variableSelected;
    this.items.map((variableSelected: any) => {
      if (variableSelected.value === this.variableSelected) {
        this.sharedService.nextVariableDashboardText = variableSelected.name;
      }
    });
  }

}
